import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function UDTradeUi({ pathname }) {
	return (
		<Box
			sx={{
				py: 4,
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				textAlign: "center",
			}}>
			<Typography variant="h4">user trade Page</Typography>
			<Typography variant="body1">Currently viewing: {pathname}</Typography>
			<Typography variant="body2">
				Functionality for buying and selling cryptocurrencies. This could
				include: Buy/Sell Order Forms: Users can place market or limit orders.
				Order Book View: See active buy and sell orders.
			</Typography>
		</Box>
	);
}

UDTradeUi.propTypes = {
	pathname: PropTypes.string.isRequired,
};
